<template>
  <div>
    <input :disabled="disabled" readonly="true" ref="datepicker" type="text" :class="!isDateValid ? 'is-invalid' : ''" class="form-control form-datepicker" :value="value" :placeholder="placeholder" v-on:change="onChange">
    <div class="input-group-append" v-on:click="show">
      <div class="input-group-text"><i class="far fa-calendar-alt"></i></div>
    </div>
    <div class="invalid-feedback">
      {{ errorMessage }}
    </div>
  </div>
</template>

<style lang="scss">
.form-control.form-datepicker[readonly] {
  background-color: #fff;
}
</style>

<script>
import 'air-datepicker/dist/css/datepicker.min.css'
import 'air-datepicker/dist/js/datepicker.min.js'
import 'air-datepicker/dist/js/i18n/datepicker.en.js'
import '@/assets/datepicker.scss'
import Vue from 'vue'

export default {
  props: {
    value: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      default: 'Select date...',
    },
    minDate: {
      type: String,
      default: () => Vue.moment.utc().format()
    },
    maxDate: {
      type: String,
      default: () => null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    updateOnScroll: {
      type: Boolean,
      default: false,
    },
    validate: {
      type: Function,
      default: null,
    },
    clearButton: {
      type: Boolean,
      default: false,
    }
  },
  name: 'date-picker',
  data: () => ({
    errorMessage: '',
    selecting: false,
    initialized: false,
    datepickerElement: null,
  }),
  mounted() {
    //console.log("mounted")
    this.$nextTick(() => this.initialize())
    if (this.updateOnScroll) {
      //console.log("[mounted] add listener")
      window.addEventListener('scroll', this.onScroll)
    }
  },
  activated() {
    //console.log("activated")
    this.$nextTick(() => this.initialize())
    if (this.updateOnScroll) {
      //console.log("[activated] add listener")
      window.addEventListener('scroll', this.onScroll)
    }
  },
  updated() {
    if (this.$refs.datepicker) $(this.$refs.datepicker).data('datepicker').selectDate(this.selectedDate)
  },
  deactivated() {
    //console.log("deactivated")
    //console.log("[deactivated] remove listener")
    window.removeEventListener('scroll', this.onScroll)
  },
  unmounted() {
    //console.log("unmounted")
    //console.log("[unmounted] remove listener")
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    onScroll() {
      if (!this.initialized) return
      if (!this.$refs.datepicker) return
      $(this.$refs.datepicker).data('datepicker').update();
    },
    show() {
      if (!this.disabled) $(this.$refs.datepicker).data('datepicker').show()
    },
    hide() {
      $(this.$refs.datepicker).data('datepicker').hide()
    },
    initialize() {
      //console.log("initializing")
      if (this.initialized) return
      //console.log("initialized")
      $(this.$refs.datepicker).datepicker({
        language: 'en',
        dateFormat: 'dd/mm-yyyy',
        clearButton: this.clearButton,
        // minDate: this.minDate,
        // maxDate: this.maxDate,
        // startDate: this.selectedDate,
        onSelect: () => this.onSelect(),
        // autoClose: true,
        onShow: (inst, ani) => this.onShow(inst, ani),
        onHide: (inst, ani) => this.onHide(inst, ani),
      })
      this.initialized = true
      this.$nextTick(() => $($(this.$refs.datepicker).data('datepicker').nav.$buttonsContainer).find('.datepicker--button[data-action="clear"]').click(() => this.clearValue()))
      this.$nextTick(() => this.updateDatepicker())
      this.selecting = true
      $(this.$refs.datepicker).data('datepicker').selectDate(this.selectedDate)
      this.selecting = false
    },
    onShow(inst, ani) {
      // console.log("showing", ani)
      if (!ani) {
        this.selecting = true
        this.$refs.datepicker.value = this.value
        $(this.$refs.datepicker).data('datepicker').selectDate(this.selectedDate)
      } else {
        this.selecting = false
      }
    },
    onHide(inst, ani) {
      // console.log("hiding", ani)
      if (ani) return
      // console.log("Emitting!", this.$refs.datepicker.value)
      this.$emit('input', this.$refs.datepicker.value)
    },
    clearValue() {
      // console.log("onclear")
      this.$refs.datepicker.value = ""
      this.hide()
    },
    onChange() {
      // console.log("onchange")
      this.hide()
    },
    onSelect() {
      // console.log("onselect", this.selecting)
      if (this.selecting) return
      // return
      if (this.$refs.datepicker.value.trim() == "") return
      this.hide()
    },
    updateDatepicker() {
      // console.log("updating datepicker")
      const minDate = this.$moment.utc(this.minDate)
      const maxDate = this.$moment.utc(this.maxDate)

      // console.log(minDate, maxDate)
      $(this.$refs.datepicker).data('datepicker').update({
        minDate: minDate.isValid() ? minDate.toDate() : new Date(),
        maxDate: maxDate.isValid() ? maxDate.toDate() : null,
        startDate: this.selectedDate,
      })
    }
  },
  computed: {
    isDateValid() {
      if (this.validate) {
        const response = this.validate(this.value)
        this.errorMessage = response ? response : ''
        return response ? false : true
      }
    },
    selectedDate() {
      return this.value && this.$moment.utc(this.value, 'DD/MM-YYYY').isValid() ? this.$moment.utc(this.value, 'DD/MM-YYYY').toDate() : null
    }
  },
  watch: {
    value: function (new_value, old_value) {
      //console.log("value: ", new_value)
      if (new_value == old_value) return
      this.initialize()
    },
    minDate: function (new_value, old_value) {
      this.updateDatepicker()
    },
    maxDate: function (new_value, old_value) {
      this.updateDatepicker()
    },
  }
}
</script>
